import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { formInjectionKey as C, formItemInstsInjectionKey as S } from "./context.js";
import M from "./styles/form.cssr.js";
import O from "../../_mixins/use-config.js";
import x from "../../_mixins/use-theme.js";
import P from "../styles/light.js";
import { keysOf as I } from "../../_utils/vue/keysOf.js";
import { defineComponent as _, provide as w, h as k } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as B } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
var F = globalThis && globalThis.__awaiter || function(t, c, o, i) {
  function h(s) {
    return s instanceof o ? s : new o(function(a) {
      a(s);
    });
  }
  return new (o || (o = Promise))(function(s, a) {
    function v(n) {
      try {
        e(i.next(n));
      } catch (m) {
        a(m);
      }
    }
    function f(n) {
      try {
        e(i.throw(n));
      } catch (m) {
        a(m);
      }
    }
    function e(n) {
      n.done ? s(n.value) : h(n.value).then(v, f);
    }
    e((i = i.apply(t, c || [])).next());
  });
};
const L = Object.assign(Object.assign({}, x.props), {
  inline: Boolean,
  labelWidth: [Number, String],
  labelAlign: String,
  labelPlacement: {
    type: String,
    default: "top"
  },
  model: {
    type: Object,
    default: () => {
    }
  },
  rules: Object,
  disabled: Boolean,
  size: String,
  showRequireMark: {
    type: Boolean,
    default: void 0
  },
  requireMarkPlacement: String,
  showFeedback: {
    type: Boolean,
    default: !0
  },
  onSubmit: {
    type: Function,
    default: (t) => {
      t.preventDefault();
    }
  },
  showLabel: {
    type: Boolean,
    default: void 0
  },
  validateMessages: Object
}), z = _({
  name: "Form",
  props: L,
  setup(t) {
    const {
      mergedClsPrefixRef: c
    } = O(t);
    x("Form", "-form", M, P, t, c);
    const o = {}, i = B(void 0), h = (f) => {
      const e = i.value;
      (e === void 0 || f >= e) && (i.value = f);
    };
    function s(f) {
      return F(this, arguments, void 0, function* (e, n = () => !0) {
        return yield new Promise((m, j) => {
          const y = [];
          for (const u of I(o)) {
            const p = o[u];
            for (const r of p)
              r.path && y.push(r.internalValidate(null, n));
          }
          Promise.all(y).then((u) => {
            const p = u.some((l) => !l.valid), r = [], d = [];
            u.forEach((l) => {
              var g, b;
              !((g = l.errors) === null || g === void 0) && g.length && r.push(l.errors), !((b = l.warnings) === null || b === void 0) && b.length && d.push(l.warnings);
            }), e && e(r.length ? r : void 0, {
              warnings: d.length ? d : void 0
            }), p ? j(r.length ? r : void 0) : m({
              warnings: d.length ? d : void 0
            });
          });
        });
      });
    }
    function a() {
      for (const f of I(o)) {
        const e = o[f];
        for (const n of e)
          n.restoreValidation();
      }
    }
    return w(C, {
      props: t,
      maxChildLabelWidthRef: i,
      deriveMaxChildLabelWidth: h
    }), w(S, {
      formItems: o
    }), Object.assign({
      validate: s,
      restoreValidation: a
    }, {
      mergedClsPrefix: c
    });
  },
  render() {
    const {
      mergedClsPrefix: t
    } = this;
    return k("form", {
      class: [`${t}-form`, this.inline && `${t}-form--inline`],
      onSubmit: this.onSubmit
    }, this.$slots);
  }
});
export {
  z as default,
  L as formProps
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/form/src/Form.js
// module id = 61
// module chunks = 41